import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpRequestService} from './http-request.service';
import {AuthService} from './authentication/auth.service';
import {AuthHelper} from '../helpers/auth.helper';
import GlobalComponent from '../../global-component';

@Injectable({
  providedIn: 'root',
})
export class QueryListService {
  // Inject services
  private httpRequestService = inject(HttpRequestService);
  private auth = inject(AuthService);
  private authHelper = inject(AuthHelper);
  private queryList: string = 'querylist';

  /**
   * Fetch dropdown data for multiple modules.
   * @param types - single number, array of numbers, or null for no filter
   * Examples:
   *   getDropdown()        -> /querylist/
   *   getDropdown(7)       -> /querylist/?types=7
   *   getDropdown([0, 1])  -> /querylist/?types=0&types=1
   */
  async getDropdown(types: number | number[] | null = null, clientId: string = ''): Promise<any> {
    // Build query parameters
    const queryParams = new URLSearchParams();
    if (types != null) {
      const typesArray = Array.isArray(types) ? types : [types];
      for (const t of typesArray) {
        queryParams.append('types', String(t));
      }
        queryParams.append('client_id', clientId);

    }
    // Convert to full URL
    const fullUrl = `${GlobalComponent.BASE_API_URL}/${this.queryList}/?${queryParams.toString()}`;

    // Grab in-memory access token (fetched earlier by getToken)
    const token = this.auth.getAccessToken() ?? '';
    if (!token) {
      // You can throw or silently proceed—depending on your auth flow.
      // Throwing makes the failure explicit:
      throw new Error('Missing access token.');
    }

    // Construct headers
    let headers = await this.authHelper.buildSignedHeaders();
    return await this.httpRequestService.executeRequest(
      fullUrl,
      headers,
      'get'
    );
  }
}
